import { ApolloError, useQuery } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { useAuth } from '@guildeducationinc/guild-auth';
import {
  EmployerConfigResponse,
  EmployerConfigVariables,
  GET_EMPLOYER_CONFIG,
} from '@src/graphql/home/queries/getEmployerConfig';
import { Server } from '@src/components/GqlProvider/GqlProvider';

/**
 * Fetch employer config from guild tuition backend.
 *
 * @packageDocumentation
 */

const useGetEmployerConfig = () => {
  const { user } = useAuth();

  const onError = (error: ApolloError): void => {
    datadogRum.addError(error, {
      type: 'guild-tuition-reimbursement-service',
      message: `There was an error getting employer config data from guild tuition: ${error}`,
    });
  };

  const { error, data, loading } = useQuery<EmployerConfigResponse, EmployerConfigVariables>(
    GET_EMPLOYER_CONFIG,
    {
      context: {
        server: Server.TUITION_REIMBURSEMENT,
      },
      variables: {
        employerId: user?.employerId || '',
      },
      skip: !user?.employerId,
      onError,
    }
  );

  return {
    error,
    employerConfig: data?.getEmployerConfig?.reimbursementWindow,
    loading,
  };
};

export default useGetEmployerConfig;
